Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* SLIDE UP */
let slideUp = (target, duration = 500) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    //alert("!");
  }, duration);
};

/* SLIDE DOWN */
let slideDown = (target, duration = 500) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};


/* TOOGLE */
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

/*================ Animations ================*/
document.addEventListener('DOMContentLoaded', function () {
gsap.registerPlugin(ScrollTrigger);

(function () {
  const blurProperty = gsap.utils.checkPrefix("filter"),
    blurExp = /blur\((.+)?px\)/,
    getBlurMatch = (target) =>
      (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

  gsap.registerPlugin({
    name: "blur",
    get(target) {
      return +getBlurMatch(target)[1] || 0;
    },
    init(target, endValue) {
      let data = this,
        filter = gsap.getProperty(target, blurProperty),
        endBlur = "blur(" + endValue + "px)",
        match = getBlurMatch(target)[0],
        index;
      if (filter === "none") {
        filter = "";
      }
      if (match) {
        index = filter.indexOf(match);
        endValue =
          filter.substr(0, index) +
          endBlur +
          filter.substr(index + match.length);
      } else {
        endValue = filter + endBlur;
        filter += filter ? " blur(0px)" : "blur(0px)";
      }
      data.target = target;
      data.interp = gsap.utils.interpolate(filter, endValue);
    },
    render(progress, data) {
      data.target.style[blurProperty] = data.interp(progress);
    },
  });
})();

// Glow Pulse
gsap.fromTo(
  ".glow",
  {
    scale: 0.5,
  },
  {
    scale: 1.4,
    yoyo: true,
    duration: 3,
    repeat: -1,
    ease: "linear",
  }
);

// Fade In Up
const fadeInUpElems = gsap.utils.toArray(".fade-in-up");
fadeInUpElems.forEach((elem) => {
  gsap.from(elem, {
    opacity: 0,
    y: 20,
    duration: 0.6,
    scrollTrigger: {
      trigger: elem,
      start: "top 80%",
    },
  });
});

});

/*================ Cookies ================*/
function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

/*================ FAQ Component ================*/
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll(".faq__item-question");
  faqs.forEach((faq) => {
    faq.addEventListener("click", (event) => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector(".faq__item-answer");

      parent.classList.toggle("active");
      slideToggle(content, 300);
    });
  });
});

/*================ Add To Cart ================*/
// Sale PLPs where Searchspring owns the grid (Liquid product-card Quick Add attrs are not used).
// Add handles here when another sale collection needs the same Quick Add disclaimer behavior.
const SALE_COLLECTION_HANDLES_FOR_QUICK_ADD_DISCLAIMER = [
  "the-end-of-season-sale-collection",
];

function isSaleCollectionQuickAddDisclaimerPage() {
  const path = window.location.pathname || "";
  return SALE_COLLECTION_HANDLES_FOR_QUICK_ADD_DISCLAIMER.some((handle) =>
    path.includes(`/collections/${handle}`)
  );
}

function getSearchspringResultTags(variantId, productCard) {
  const results = window.searchspring?.controller?.search?.store?.results;
  if (!results) return [];

  const list = Array.from(results);
  const productId =
    productCard?.getAttribute?.("data-product-id") ||
    productCard?.dataset?.productId;
  let result = list.find(
    (item) =>
      String(item.id) === String(productId) ||
      String(item.mappings?.core?.uid) === String(productId)
  );

  // Color swatches can leave data-product-id stale; match the clicked variant when needed.
  if (!result && variantId) {
    result = list.find((item) => {
      const variants = item.custom?.sizeVariants || [];
      return Array.from(variants).some(
        (variant) => String(variant.id) === String(variantId)
      );
    });
  }

  if (!result?.attributes?.tags) return [];
  try {
    return Array.from(result.attributes.tags);
  } catch (e) {
    return String(result.attributes.tags)
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);
  }
}

function applySaleDisclaimerFromSearchspring(properties, variantId, target) {
  if (!isSaleCollectionQuickAddDisclaimerPage()) return;

  const productCard = target.closest?.("product-card");
  const tags = getSearchspringResultTags(variantId, productCard);
  if (!tags.length) return;

  const hasFinalSale = tags.some((tag) => {
    const handleized = String(tag).toLowerCase().replace(/\s+/g, "-");
    return tag === "Final Sale" || handleized === "final-sale";
  });
  const hasStoreCreditOnly = tags.includes("Store Credit Only");

  if (hasFinalSale) {
    properties.Disclaimer = "Final Sale";
  }
  // Match PDP buy-buttons: Store Credit Only wins if both tags are present
  if (hasStoreCreditOnly) {
    properties.Disclaimer = "Store Credit Only";
  }
}

const atcButtons = document.querySelectorAll(".js-add-to-cart");
document.body.addEventListener("click", (event) => {
  if (event.target.classList.contains("js-add-to-cart")) {
    event.preventDefault();
    const id = Number(event.target.dataset.id);
    const isPreSalePresent = event.target.dataset?.isPreSale;
    const isFinalSalePresent = event.target.dataset?.isFinalSale;
    const isStoreCreditOnlyPresent = event.target.dataset?.isStoreCreditOnly;
    const properties = {};

    if (isPreSalePresent === "true") {
      properties._isPreSale = "true";
    }
    if (isFinalSalePresent === "true") {
      properties.Disclaimer = "Final Sale";
    }
    // Match PDP buy-buttons: Store Credit Only wins if both tags are present
    if (isStoreCreditOnlyPresent === "true") {
      properties.Disclaimer = "Store Credit Only";
    }

    // Sale Searchspring PLPs: set Disclaimer from indexed product tags (scoped by collection handle).
    applySaleDisclaimerFromSearchspring(properties, id, event.target);

    const item = {
      id: id,
      quantity: 1,
    };
    if (Object.keys(properties).length > 0) {
      item.properties = properties;
    }

   fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [item]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          return;
        }

        if (window.mondaySwimwearSlBandCupNotice && typeof window.mondaySwimwearSlBandCupNotice.checkResponse === 'function') {
          window.mondaySwimwearSlBandCupNotice.checkResponse(result.data);
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {"onSuccessDo" : "force_open_drawer"}
        })); 

        // Open cart drawer directly without toggling (keeps it open if already open)
        const cartDrawer = document.querySelector('cart-drawer');
        const isDrawerOpen = cartDrawer && window.getComputedStyle(cartDrawer).display === 'block';
        
        if (!isDrawerOpen) {
          const cartLink = document.querySelector('.relative.header__cart-link>a');
          if (cartLink) {
            cartLink.click();
          }
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      })
  }
});

// function atcGetSectionsToRender() {
//   const drawer = document.querySelector("cart-drawer");
//   const shadow = drawer ? drawer.shadowRoot : null;

//   const contentEl = shadow
//     ? shadow.getElementById("cart-drawer__content")
//     : null;

//   return [
//     {
//       id: "cart-drawer",
//       section: "cart-drawer",
//       selector: "cart-drawer",
//     },
//     {
//       id: "cart-icon-bubble",
//       section: "cart-icon-bubble",
//       selector: ".shopify-section",
//     },
//     {
//       id: "cart-icon-bubble-header",
//       section: "cart-icon-bubble",
//       selector: ".shopify-section",
//     },
//   ];
// }




class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll(".product-card__swatch");
    this.quickAdd = this.querySelectorAll(".product-card__button");
    this.cardImage = this.querySelector(
      ".product-card__image .initial-image img"
    );
    this.cardHoverImage = this.querySelector(
      ".product-card__image .hover-image img"
    );
    this.productTitle = this.querySelector(".product-card__title");
    this.links = this.querySelectorAll(".product-card__link");
    /* SC DEV - HACK because on Safari 26, it seems like links don't actually work on the product cards */
    // this.links.forEach(element => {
    //   element.addEventListener("click", event => {
    //     var cp = event.composedPath();
    //     console.log(cp);
    //     if (cp[0] !== element && cp[1] !== element && cp[2] !== element && cp[3] !== element) return;
    //     window.location = element.getAttribute("href");
    //   });
    // });
    this.soldout = this.querySelector(".product-card__link .sold-out__tag");
    this.card = this.querySelector(".product-card__image");

    this.handleSwatchClick = (swatch, event) => {
      event.preventDefault();
      event.stopPropagation();
      this.onSwatchClick(swatch);
    };

    this.swatches.forEach((swatch) => {
      swatch.addEventListener(
        "click",
        this.handleSwatchClick.bind(this, swatch)
      );
    });
  }

  onSwatchClick(swatch, event) {
    if (!swatch.classList.contains("active")) {
      const isVariant = swatch.dataset.isVariant;
      
      this.updateActiveSwatch(swatch);
      this.updateImages(swatch);
      this.updateTitle(swatch);
      this.updateLinks(swatch);
      this.updatePrice(swatch);
      if (isVariant != 'true') {
        this.updateVariants(swatch);
      }
    }
  }

  updateActiveSwatch(swatch) {
    this.swatches.forEach((swatch) => {
      swatch.classList.remove("active");
    });

    swatch.classList.add("active");
  }

  updateVariants(swatch) {
    const variant = swatch.dataset.title;
    this.quickAdd.forEach((button) => {
      if (button.dataset.button == variant) {
        button.style.display = "block";
        button.classList.add("active");
      } else {
        button.style.display = "none";
        button.classList.remove("active");
      }
    });
  }

  updateImages(swatch) {
    const image = swatch.dataset.image;
    const hoverImage = swatch.dataset.hover;
    const available = swatch.dataset.available;

    if (available == "true") {
      this.card.style.opacity = "1";
      this.soldout.style.display = "none";
    } else {
      this.card.style.opacity = "0.5";
      this.soldout.style.display = "block";
    }

    this.cardImage.setAttribute("src", image);
    if (this.cardHoverImage) {
      this.cardHoverImage.setAttribute("src", hoverImage);
    }
  }

  updateTitle(swatch) {
    const title = swatch.dataset.title;

    this.productTitle.innerHTML = title;
  }

  updateLinks(swatch) {
    const url = swatch.dataset.url;

    this.links.forEach((link) => {
      link.setAttribute("href", url);
    });
  }

  updatePrice(swatch) {
    const priceContainer = this.querySelector(".product-card__price-container");
    const currency = swatch.dataset.currency;
    const price = swatch.dataset.price;
    const compareAtPrice = swatch.dataset.comparePrice;

    if (compareAtPrice > price) {
      const priceHTML = `
      <div class="price product-card__price body-small price--on-sale">
        <span class="price-item price-item--regular">
          <span class="money"></span>
        </span>
        <div class="price__sale">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span>
            <s class="price-item price-item--regular">
              <span class="money">${Shopify.formatMoney(
                compareAtPrice
              )} ${currency}</span>
            </s>
          </span>
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
          <span class="price-item price-item--sale price-item--last">
            <span class="money">${Shopify.formatMoney(price)} ${currency}</span>
          </span>
        </div>
      </div>
      `;

      this.clearElement(priceContainer);
      priceContainer.insertAdjacentHTML("beforeend", priceHTML);
    } else {
      const priceHTML = `
        <div class="price product-card__price body-small">
        <div><div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">
              <span class="money">${Shopify.formatMoney(
                price
              )} ${currency}</span>
            </span>
          </div>
          <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span>
                <s class="price-item price-item--regular">
                    <span class="money"></span>
                </s>
              </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last">
              <span class="money">${Shopify.formatMoney(
                price
              )} ${currency}</span>
            </span>
          </div>
          <small class="unit-price caption hidden">
            <span class="visually-hidden">Unit price</span>
            <span class="price-item price-item--last">
              <span></span>
              <span aria-hidden="true">/</span>
              <span class="visually-hidden">&nbsp;per&nbsp;</span>
              <span>
              </span>
            </span>
          </small>
        </div></div>
      `;

      this.clearElement(priceContainer);
      priceContainer.insertAdjacentHTML("beforeend", priceHTML);
    }
  }

  clearElement(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }
}

customElements.define("product-card", ProductCard);